import { IPublicUserData } from './public-user-data.interface';

export interface IReloginResponseDTO {
  token: string;
  reloginToken: string;
  user: IPublicUserData;
}